import React from "react";
import { SeparatorStyled } from "./style";

const Separators = ({ ...props }) => {
  return <SeparatorStyled {...props} data-testid="separators" />;
};

export default Separators;
